// tslint:disable
/**
 * @module support/pdl/constants
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const INFOBAR_MAP = {
  billing: 'Billing',
  usage: 'Usage',
  memo: 'Memo',
  log: 'Activity Log',
  favorites: 'Quick Links',
};

export const VIDEO_CONSTANTS = {
  VIDEO_TAG: 'VIDEO',
  SOURCE_TAG: 'SOURCE',
};

export const PDL_EVENT_CONSTANT = {
  HIFEN: ' - ',
  ZERO: 0,
  PREPAID_URL: '/prepaid',
  PREPAID_CONST: 'prepaid',
  PREPAID_PAGE_NAME: 'prepaid.index',
  CART: 'cart',
  MODAL: 'modal',
  CHECK_ORDER_STATUS_CONST: 'Check Order Status',
  SPACE: ' ',
  PAUSED: 'paused',
  ACTIVITY_DATE: 'Activity Date',
  ACTIVITY_TYPE: 'Activity Type',
  ACTIVITY_LINE: 'Customer Line',
  ACTIVITY_VIEW: 'Customer View',
  GLOBAL_SEARCH_KEY: 'GLOBAL_SEARCH',
  INTERNAL_CAMPAIGN_KEY: 'INTERNAL_CAMPAIGN',
  PRODUCT_SELECTION_KEY: 'PRODUCT_SELECTION',
  ADD_A_LINE_KEY: 'ADD_A_LINE',
  ALERT_IMPRESSION_KEY: 'ALERT_IMPRESSION_CLICK',
  FORM_KEY: 'FORM',
  DEFAULT_KEY: 'DEFAULT',
  ADD_TO_CART_KEY: 'ADD_TO_CART',
  LOGIN_COMPLETE_KEY: 'LOGIN_COMPLETE',
  LOGIN_START_KEY: 'LOGIN_START',
  WEB_GUARD_START_KEY: 'WEB_GUARD_START',
  WEB_GUARD_COMPLETE_KEY: 'WEB_GUARD_COMPLETE',
  FAMILY_ALLOWANCE_START_KEY: 'FAMILY_ALLOWANCE_START',
  FAMILY_ALLOWANCE_COMPLETE_KEY: 'FAMILY_ALLOWANCE_COMPLETE',
  PRICE_CHANGE_NOTIFICATION_KEY: 'PRICE_CHANGE_NOTIFICATION',
  EMPLOYEE_DESIGNATION_START_KEY: 'EMPLOYEE_DESIGNATION_START',
  EMPLOYEE_DESIGNATION_COMPLETE_KEY: 'EMPLOYEE_DESIGNATION_COMPLETE',
  SEARCH_RESULT_CLICK_KEY: 'SEARCH_RESULT_CLICK',
  MODIFY_AUTO_PAY_PREFERENCES_KEY: 'MODIFY_AUTO_PAY_PREFERENCES',
  PDL_MODIFY_DATA_STASH_START_PREFERENCES_KEY: 'PDL_MODIFY_DATA_STASH_START_PREFERENCES',
  PDL_MODIFY_DATA_STASH_COMPLETE_PREFERENCES_KEY: 'PDL_MODIFY_DATA_STASH_COMPLETE_PREFERENCES',
  PDL_SUSPEND_SERVICE_PREFERENCES_KEY: 'PDL_SUSPEND_SERVICE_PREFERENCES',
  PDL_RESTORE_FROM_SUSPENDED_START_PREFERENCES_KEY: 'PDL_RESTORE_FROM_SUSPENDED_START_PREFERENCES',
  PDL_RESTORE_FROM_SUSPENDED_COMPLETE_PREFERENCES_KEY:
    'PDL_RESTORE_FROM_SUSPENDED_COMPLETE_PREFERENCES',
  PDL_SUSPEND_SERVICE_COMPLETE_PREFERENCES_KEY: 'PDL_SUSPEND_SERVICE_COMPLETE_PREFERENCES',
  VIDEO_COMPLETE_KEY: 'VIDEO_COMPLETE',
  MODIFY_PAYMENT_START_KEY: 'MODIFY_PAYMENT_START',
  MODIFY_PAYMENT_COMPLETE_KEY: 'MODIFY_PAYMENT_COMPLETE',
  PDL_APPLY_CREDIT_START_KEY: 'APPLY_CREDIT_START',
  PDL_APPLY_CREDIT_COMPLETE_KEY: 'APPLY_CREDIT_COMPLETE',
  RETURN_EXCHANGE_COMPLETE_KEY: 'RETURN_EXCHANGE_COMPLETE',
  EDIT_EMAIL_COMPLETE_KEY: 'EDIT_EMAIL_COMPLETE',
  LOGIN_FORM_NAME: 'loginForm',
  LOGIN_COMPLETE: 'loginComplete',
  BLOCKING_FORM: 'blockingForm',
  RETURN_EXCHANGE_FORM_START: 'returnExchangeForm',
  RETURN_EXCHANGE_FORM_COMPLETE: 'returnExchangeForm complete',
  RETURN_EXCHANGE_FORM_COMPLETE_FORMNAME: 'returnExchangeForm',
  EDIT_EMAIL_FORM_COMPLETE: 'editEmail complete',
  EDIT_EMAIL_FORM_COMPLETE_FORMNAME: 'editEmail',
  REPDASH_FOLLOW_UP_EVENT: 'repdash followup',
  REPDASH_MEMO_CREATION_EVENT: 'memo creation',
  EMPTY_STRING: ' ',
  COMMA_SEPERATION: ',',
  SUBMIT_TEXT: 'submit',
  SAVE_TEXT: 'save',
  PROSPECT: 'prospect',
  KEYBOARD_ENTER_EVENT: 13,
  COMPLETE_TEXT: 'complete',
  START_TEXT: 'start',
  IMPRESSION_TEXT: 'impression',
  SEARCH_RESULT_CLICK_ATTRIBUTE: 'pdl-search-result-click',
  ALERT_IMPRESSION_CLICK_ATTRIBUTE: 'pdl-alert-impression-click',
  ADD_A_LINE_BUTTON_ATTRIBUTE: 'pdl-add-a-line-button',
  GLOBAL_SEARCH_TERM_BUTTON_ATTRIBUTE: 'pdl-search-button',
  GLOBAL_SEARCH_TERM_INPUT_ATTRIBUTE: 'pdl-search-input',
  GLOBAL_SEARCH_TERM_AUTOSEARCH_ATTRIBUTE: 'pdl-search-autoSuggest',
  OVER_THE_PHONE_CATEGORY: ['shop', 'plans', 'cart'],
  GLOBAL_PDL_ADD_TO_CART_ATTRIBUTE: 'pdl-add-to-cart-track',
  PRODUCT_SELECTION_ATTRIBUTE: 'pdl-track-product-selection',
  BROWSE_PLANS_ATTRIBUTE: 'pdl-track-browse-plans',
  BROWSE_ACCESSORIES_ATTRIBUTE: 'pdl-track-browse-accessories',
  WEB_GUARD_ATTRIBUTE: 'pdl-track-web-guard',
  FAMILY_ATTRIBUTE: 'pdl-track-family',
  WEB_GUARD_AND_FAMILY_ATTRIBUTE: 'pdl-track-family-webguard',
  WEB_FAMILY_COMPLETE_ATTRIBUTE: 'pdl-track-web-gaurd-family-complete',
  LOGIN_PAGE_NAME: 'login',
  YES: 'Yes',
  HOME_PAGE_NAME: 'Home Page',
  MY_ACCOUNT_PAGE_NAME: 'myT-Mobile',
  CUSTOMER_AUTH_PAGE_NAME: 'customerauthentication',
  ORDER_SUMMARY_STATE: ['prepaid.mytmobile.warranty-returnExchange.itemSelection'],
  ORDER_SUMMARY_KEY: 'CHECK_ORDER_STATUS',
  NOTIFICATION_STATE: [
    'notificationCenterWeb',
    'notificationCenterCare',
    'notificationCenterRetail',
    'prepaid.mytmobile.manageprofile.marketingsettings',
    'prepaid.mytmobile.manageprofile.notifications',
    'prepaid.mytmobile.manageprofile.otherlinesettings',
    'prepaid.mytmobile.manageprofile.privacysettings',
    'prepaid.mytmobile.manageprofile.communicationmethod',
  ],
  BLOCKING_STATE: [
    'blockingControlsWeb',
    'blockingControlsCare',
    'blockingControlsRetail',
    'blockingctrls',
  ],
  EMP_DESIGNATION_STATE: [
    'employeeLineDesignationWeb',
    'employeeLineDesignationCare',
    'employeeLineDesignationRetail',
  ],
  EQUIP_INST_PLAN_STATE: ['equipmentInstallmentPlanConfirmation'],
  PRE_PAID_CONF_ONE_TIME_PAY_STATE: [
    'prepaidConfirmOneTimePaymentWeb',
    'prepaidConfirmOneTimePaymentCare',
    'prepaidConfirmOneTimePaymentRetail',
  ],
  DEVICE_DETAIL_STATE: 'device-details',
  MANAGE_AUTO_PAY_STATE: ['autopay'],
  MAKE_ONE_TIME_PAYMENT_STATE: [
    'prepaid.mytmobile.one-time-paymentRetail',
    'prepaid.mytmobile.one-time-paymentCare',
    'prepaid.mytmobile.one-time-paymentWeb',
  ],
  CONF_MANAGE_AUTO_PAY_STATE: [
    'confirmSetUpWeb',
    'confirmSetUpCare',
    'confirmSetUpRetail',
    'confirm-autopay',
  ],
  CONF_MAKE_ONE_TIME_PAYMENT_STATE: [
    'prepaid.mytmobile.one-time-payment-confirmRetail',
    'prepaid.mytmobile.one-time-payment-confirmCare',
    'prepaid.mytmobile.one-time-payment-confirmWeb',
  ],
  IMEI_BLOCK_CHECK_STATE: ['imeiBlockCheckStatus', 'check-unlock-status'],
  BLOCKING_PREFERENCES_COMPLETE: 'update blocking preferences',
  COMMUNICATION_PREFERENCES_COMPLETE: 'update communication preferences',
  NOTIFICATION_START_KEY: 'COMMUNICATION_PREFERENCES',
  BLOCKING_START_KEY: 'BLOCKING_PREFERENCES',
  EQUIP_INST_PLAN_CONF_KEY: 'EQUIP_INST_PLAN_PREFERENCES',
  PRE_PAID_CONF_ONE_TIME_PAY_KEY: 'PRE_PAID_CONF_ONE_TIME_PAY_PREFERENCES',
  MANAGE_AUTO_PAY_KEY: 'MANAGE_AUTO_PAY_PREFERENCES',
  MODIFY_AUTO_PAY_START_KEY: 'MODIFY_AUTO_PAY_START_PREFERENCES',
  MAKE_ONE_TIME_PAYMENT_KEY: 'MAKE_ONE_TIME_PAYMENT_PREFERENCES',
  CONF_MAKE_ONE_TIME_PAYMENT_KEY: 'CONF_MAKE_ONE_TIME_PAYMENT_KEY_PREFERENCES',
  CONF_MANAGE_AUTO_PAY_KEY: 'CONF_MANAGE_AUTO_PAY_PREFERENCES',
  START_CANCEL_AUTO_PAY_PREFERENCES_KEY: 'START_CANCEL_AUTO_PAY_PREFERENCES',
  COMPLETE_CANCEL_AUTO_PAY_PREFERENCES_KEY: 'COMPLETE_CANCEL_AUTO_PAY_PREFERENCES',
  IMEI_BLOCK_CHECK_STATE_KEY: 'IMEI_BLOCK_CHECK_PREFERENCES',
  LOST_STOLEN_COMPLETE_STATE: ['devicelostconfirm'],
  CPS_ALL_PLANS_STATE: ['prepaid.mytmobile.cps.rate-plans'],
  CPS_ALL_PLANS_KEY: 'CPS_ALL_PLANS_START',
  LOST_STOLEN_STATE: ['prepaid.devicelostreport'],
  LOST_STOLEN_KEY: 'LOST_STOLEN_PREFERENCES',
  BLOCKING_PREFERENCES_COMPLETE_KEY: 'BLOCKING_PREFERENCES_COMPLETE',
  COMMUNICATION_PREFERENCES_COMPLETE_KEY: 'COMMUNICATION_PREFERENCES_COMPLETE',
  IMEI_BLOCK_CHECK_COMPLETE: 'check-unlock-status',
  IMEI_BLOCK_CHECK_COMPLETE_START_KEY: 'IMEI_BLOCK_CHECK_COMPLETE_PREFERENCES',
  CHECK_UNLOCK_STATUS_SUB_STATES: [
    'device-unlock-success',
    'device-unlock-success-repeat',
    'device-unlock-delayed',
    'device-unlock-delayed-repeat',
  ],
  LOST_STOLEN_DEVICE_COMPLETE: 'lost-stolen-device-detail-complete',
  LOST_STOLEN_DEVICE_COMPLETE_START_KEY: 'LOST_STOLEN_DEVICE_COMPLETE_PREFERENCES',
  PROFILE_NAME_START_KEY: 'PROFILE_NAME_START',
  PROFILE_NAME_COMPLETE_KEY: 'PROFILE_NAME_COMPLETE',
  PROFILE_EMAIL_START_KEY: 'PROFILE_EMAIL_START',
  PROFILE_EMAIL_COMPLETE_KEY: 'PROFILE_EMAIL_COMPLETE',
  PROFILE_PHONE_NUMBER_START_KEY: 'PROFILE_PHONE_NUMBER_START',
  PROFILE_PHONE_NUMBER_COMPLETE_KEY: 'PROFILE_PHONE_NUMBER_COMPLETE',
  PROFILE_PASSWORD_START_KEY: 'PROFILE_PASSWORD_START',
  PROFILE_SECURITY_QUESTIONS_START_KEY: 'PROFILE_SECURITY_QUESTIONS_START',
  PROFILE_PASSWORD_COMPLETE_KEY: 'PROFILE_PASSWORD_COMPLETE',
  PROFILE_SECURITY_QUESTIONS_COMPLETE_KEY: 'PROFILE_SECURITY_QUESTIONS_COMPLETE',
  PROFILE_BILLING_START_KEY: 'PROFILE_BILLING_START',
  PROFILE_BILLING_COMPLETE_KEY: 'PROFILE_BILLING_COMPLETE',
  PROFILE_E911_START_KEY: 'PROFILE_E911_START',
  PROFILE_E911_COMPLETE_KEY: 'PROFILE_E911_COMPLETE',
  PDL_STATE_NAME: 'prepaid.shop.devicedetails',
  PROFILE_NAME_START_ATTRIBUTE: 'pdl-track-profile-name-update',
  PROFILE_NAME_COMPLETE_ATTRIBUTE: 'pdl-track-profile-name-update-complete',
  PROFILE_EMAIL_START_ATTRIBUTE: 'pdl-track-profile-email-update',
  PROFILE_EMAIL_COMPLETE_ATTRIBUTE: 'pdl-track-profile-email-update-complete',
  PROFILE_PHONE_NUMBER_START_ATTRIBUTE: 'pdl-track-profile-phone-number-update',
  PROFILE_PHONE_NUMBER_COMPLETE_ATTRIBUTE: 'pdl-track-profile-phone-number-update-complete',
  PROFILE_PASSWORD_START_ATTRIBUTE: 'pdl-track-profile-password-update',
  PROFILE_SECURITY_QUESTIONS_START_ATTRIBUTE: 'pdl-track-profile-security-questions-update',
  PROFILE_PASSWORD_COMPLETE_ATTRIBUTE: 'pdl-track-profile-password-update-complete',
  PROFILE_SECURITY_QUESTIONS_COMPLETE_ATTRIBUTE:
    'pdl-track-profile-security-questions-update-complete',
  PROFILE_BILLING_ADDRESS_START_ATTRIBUTE: 'pdl-track-profile-billing-address-update',
  PROFILE_BILLING_ADDRESS_COMPLETE_ATTRIBUTE: 'pdl-track-profile-billing-address-update-complete',
  PROFILE_EMERGENCY_ADDRESS_START_ATTRIBUTE: 'pdl-track-emergency-address-update',
  PROFILE_EMERGENCY_ADDRESS_COMPLETE_ATTRIBUTE: 'pdl-track-emergency-address-update-complete',
  PROFILE_BLOCKING_PREFERENCES_COMPLETED_ATTRIBUTE: 'pdl-track-blocking-preference-complete',
  PROFILE_COMMUNICATION_PREFERENCES_COMPLETED_ATTRIBUTE:
    'pdl-track-communication-preference-complete',
  SIM_CHANGE_START_ATTRIBUTE: 'pdl-change-sim-start',
  SIM_CHANGE_START_KEY: 'SIM_CHANGE_START',
  SIM_CHANGE_COMPLETE_ATTRIBUTE: 'pdl-change-sim-complete',
  SIM_CHANGE_START_STATE: 'changesim',
  SIM_CHANGE_COMPLETE_KEY: 'SIM_CHANGE_COMPLETE',
  EMPLOYEE_DESIGNATION_COMPLETED_ATTRIBUTE: 'pdl-track-employee-designation-complete',
  MAKE_PAYMENT_ARRANGEMENT_STATE: 'paymentArrangement',
  MAKE_PAYMENT_ARRANGEMENT_START_KEY: 'MAKE_PAYMENT_ARRANGEMENT_START',
  USER_REGISTRATION_START_ATTRIBUTE: 'pdl-track-user-registration-start',
  USER_REGISTRATION_START_KEY: 'USER_REGISTRATION_START',
  USER_REGISTRATION_COMPLETE_KEY: 'USER_REGISTRATION_COMPLETE',
  PDL_CANCEL_LINES: 'pdl-cancel-lines',
  PDL_RESUME_LINES: 'pdl-resume-lines',
  PDL_MODIFICATION: 'pdl-modify-cancellation',
  PDL_MOVE_A_LINE: 'pdl-move-a-lines',
  PDL_EDITHANDLING: 'pdl-edit-handling',
  PDL_SUSPEND_SERVICE_START: 'pdl-track-suspend-service-start',
  PDL_CPS_CONTINUE_BUTTON: 'pdl-cps-service-continue-button',
  PDL_MODIFY_DATA_STASH_START: 'pdl-track-modify-data-stash-start',
  PDL_MODIFY_DATA_STASH_COMPLETE: 'pdl-track-modify-data-stash-complete',
  PDL_SUSPEND_SERVICE_COMPLETE: 'pdl-track-suspend-service-complete',
  PDL_MODIFY_CANCELLATION_START: 'pdl-track-modify-cancellation-start',
  PDL_MODIFY_CANCELLATION_COMPLETE: 'pdl-track-modify-cancellation-complete',
  PDL_REPDASH_ACTIVITY_TYPE_FILTER: 'pdl-repdash-activity-type-filter',
  PDL_REPDASH_ACTIVITY_TYPE_VALUE: 'activitySeacrhInitiated',
  PDL_REPDASH_ACTIVITY_CLICK_EVENT: 'PDL_REPDASH_ACTIVITY_CLICK',
  REPDASH_USAGE_FILTER_EVENT: 'pdl-repdash-usage-filter',
  REPDASH_USAGE_FILTER_CLICK_EVENT: 'REPDASH_USAGE_FILTER_CLICK',
  REPDASH_MRC_FILTER_EVENT: 'pdl-repdash-mrc-filter',
  REPDASH_MRC_FILTER_CLICK_EVENT: 'REPDASH_MRC_FILTER_CLICK',
  PDL_RESTORE_FROM_SUSPENDED_START: 'pdl-restore-from-suspend-start',
  PDL_RESTORE_FROM_SUSPENDED_COMPLETE: 'pdl-restore-from-suspend-complete',
  ACCOUNT_SETUP_REGISTRATION: 'account-and-billing-info',
  LINE_SETUP: 'line setup',
  PREPAID_ONE_TIME_PAYMENT_STATE: [
    'prepaidOneTimePaymentWeb',
    'prepaidOneTimePaymentRetail',
    'prepaidOneTimePaymentCare',
  ],
  PREPAID_ONE_TIME_PAYMENT_START_KEY: 'PREPAID_ONE_TIME_PAYMENT_START',
  EQUIPMENTINSTALLMENTPLAN_STATE: 'equipmentInstallmentPlan',
  EQUIPMENT_INSTALLMENT_PLAN_START_KEY: 'EQUIPMENT_INSTALLMENT_PLAN_START',
  PROFILE_PAPERLESS_BILLING_START_ATTRIBUTE: 'pdl-track-paperless-billing-start',
  PROFILE_PAPERLESS_BILLING_COMPLETE_ATTRIBUTE: 'pdl-track-paperless-billing-complete',
  PROFILE_PAPERLESS_BILLING_START_KEY: 'PROFILE_PAPERLESS_BILLING_START',
  PROFILE_PAPERLESS_BILLING_COMPLETE_KEY: 'PROFILE_PAPERLESS_BILLING_COMPLETE',
  DEVICE_SELECTOR_STATE: [
    'browseDevicesWeb',
    'browseDevicesRetail',
    'browseDevicesCare',
    'browseAccessoriesCare',
    'browseAccessoriesRetail',
    'browseAccessoriesWeb',
    'browseRefillCardCare',
    'browseRefillCardWeb',
    'browseRefillCardRetail',
  ],
  PLAN_SELECTOR_STATE: [
    'plansWeb',
    'plansCare',
    'plansRetail',
    'plansLineCare',
    'plansLineWeb',
    'plansLineRetail',
  ],
  BYOD_STATE: [
    'byod.imeiCheck',
    'prepaid.byodimeiCheck',
    'prepaid.byodquestions',
    'prepaid.browsedevices',
    'prepaid.browsetablets',
    'prepaid.cart.landing',
    'prepaid.cart.line-setup',
    'prepaid.cart.login',
    'prepaid.cart.orderConfirm',
    'prepaid.cart.orderpayment',
    'prepaid.cart.orderReview',
    'prepaid.cart.orderShipping',
    'suspensionConfirmation',
    'suspendServicephone',
    'prepaid.mytmobile',
    'prepaid.mytmobile.activity-log',
    'autopay',
    'prepaid.mytmobile.billing',
    'prepaid.mytmobile.billingdetailsWeb',
    'transactionhistory',
    'prepaid.createCharge',
    'prepaid.mytmobile.equipment-refund',
    'prepaid.mytmobile.transactionhistory.fraud-routing',
    'negative-file-request',
    'callDetailRecords',
    'prepaid.mytmobile.cps.pendingorder',
    'prepaid.mytmobile.cps.product-detail',
    'confirm-autopay',
    'prepaid.mytmobile.one-time-payment-review',
    'prepaidUnauthuserPaymentMigrationCheck',
    'prepaid.mytmobile.manageprofile',
    'prepaid.mytmobile.manageprofile.storedpaymentmethods',
    'prepaid.mytmobile.redeem-a-refill-card',
    'review-autopay',
    'prepaid.mytmobile.warranty-returnExchange',
    'prepaid.mytmobile.warranty-returnExchange.returnForm.remorseAssessItem',
    'prepaid.mytmobile.warranty-returnExchange.returnForm.remorseOrderSummary',
    'prepaid.mytmobile.warranty-returnExchange.returnForm.remorseValidateDevice',
    'prepaid.mytmobile.warranty-returnExchange.returnForm.warrantyAssessItem',
    'prepaid.mytmobile.warranty-returnExchange.returnForm.warrantyValidateDevice',
    'prepaid.dataplans',
    'prepaid.individualplans',
    'prepaid.browserefillcards',
    'prepaidUnauthuserPaymentMigrationCheck',
    'prepaid.unauthOneTimePaymentConfirmation',
    'submitRefundRequest',
    'prepaid.mytmobile.warranty-returnExchange.itemSelection',
    'prepaid.shop.comparedevices',
    'prepaid.browseAccessories',
    'prepaid.shop.selector.device',
    'prepaid.shop.selector.accountconflict',
    'prepaid.shop.selector.cartconflict',
    'changeMsisdn.successConfirm',
    'prepaid.check-unlock-status',
    'changeMsisdn.msisdnEditNumWeb',
    'prepaid.imeiBlockCheckStatus',
    'prepaid.shop.selector.cartconflict',
    'prepaid.devicelostconfirm',
    'prepaid.devicelostreport',
    'accessPuk',
  ],
  DEVICE_FIRST: 'device-first',
  PLAN_FIRST: 'plan-first',
  BYOD_FIRST: 'BYOD',
  CATEGORY_FOR_TRACK_VARIENT: ['Shop', 'Cart', 'Plans', 'myaccount'],
  ADD_A_LINE_EVENT: 'add a line',
  ALERT_IMPRESSION_CLICK_EVENT: 'account action user alert',
  ORDER_ID: null,
  ORDER_TYPE: 'ADDALINE',
  NAV_CLICK_EVENT_ATTRIBUTE: 'pdl-track-nav-attribute',
  NAV_CLICK_EVENT_KEY: 'NAV_CLICK_EVENT',
  MOVE_A_LINE_CLICK_EVENT: 'MOVE_A_LINE_CLICK',
  CPS_ADD_FEATURE_CLICK_EVENT: 'CPS_ADD_FEATURE_CLICK',
  RESUME_LINE_CLICK_EVENT: 'RESUME_LINE_CLICK',
  MODIFY_CANCELLATION_START_EVENT: 'MODIFY_CANCELLATION_START',
  MODIFY_CANCELLATION_COMPLETE_EVENT: 'MODIFY_CANCELLATION_COMPLETE',
  CANCEL_LINES_CLICK_EVENT: 'CANCEL_LINES_CLICK',
  MODIFICATION_CLICK_EVENT: 'MODIFICATION_CLICK',
  EDITHANDLING_CLICK_EVENT: 'EDITHANDLING_CLICK',
  INFOBAR_EVENT_ATTRIBUTE: 'pdl-track-infobar-attribute',
  INFOBAR_CLICK_EVENT_KEY: 'INFOBAR_CLICK_EVENT',
  HTTP: 'http',
  NG_HREF: 'ng-href',
  PAGE_LOAD: 'PAGE_LOAD',
  HARDGOOD: 'Hardgood',
  SERVICE: 'Service',
  NON_NETWORK: 'Non-network',
  DISCOUNT: 'Discount',
  POSTPAY_ACCOUNT: 'postpay',
  BASE_SERVICE: 'base',
  ADD_ON_SERVICE: 'add-on',
  ORDERTYPE_REFILL_CART: 'Refill Cart',
  API_ERROR_KEY: 'API_ERROR',
  USER_ERROR_KEY: 'USER_ERROR',
  ERROR_ACTION: 'error',
  ADDED: 'Added',
  USER_VALIDATION_ERROR: 'userValidationError',
  PIN_CHECK_BOX: 'pdl-track-pin-check-box',
  PHOTO_CHECK_BOX: 'pdl-track-photo-check-box',
  PDL_LOOKUP: 'pdl-lookup',
  BYPASS_LINK: 'pdl-track-bypass-link',
  PIN_CHECK_BOX_KEY: 'PIN_CHECK_BOX_PREFERENCES',
  CUSTOMER_LOOKUP: 'CUSTOMER_LOOKUP_PREFRENCES',
  ORDER_LOOKUP: 'ORDER_LOOKUP_PREFRENCES',
  PROMOTION_LOOKUP: 'PROMOTION_LOOKUP_PREFRENCES',
  SUBMIT_FOLLOWUP: 'pdl-submit-followup',
  SUBMIT_FOLLOWUP_KEY: 'SUBMIT_FOLLOWUP_PREFRENCES',
  PIN: 'pin',
  PHOTO_ID: 'photo id',
  BYPASS: 'bypass',
  CUSTOMER_VERIFICATION: 'customer verification',
  COURTESY_COMPLETE: 'courtesyCreditForm complete',
  COURTESY_COMPLETE_FORMNAME: 'courtesyCreditForm',
  SWITCH_ACCOUNT: 'pdl-track-switch-account',
  SWITCH_ACCOUNT_KEY: 'SWITCH_ACCOUNT_PREFERENCES',
  CUSTOMER: 'customer',
  ORDER: 'order',
  PROMOTION: 'promotion',
  SEARCH_INITIATION: 'search initiation',
  PDL_ORDER_SUMMARY_STATE: [
    'prepaid.mytmobile.warranty-returnExchangeWeb',
    'prepaid.mytmobile.warranty-returnExchangeRetail',
    'prepaid.mytmobile.warranty-returnExchangeCare',
  ],
  PDL_VIDEO_PROGRESS_25: '25% viewed',
  PDL_VIDEO_PROGRESS_50: '50% viewed',
  PDL_VIDEO_PROGRESS_80: '80% viewed',
  ORDER_SUMMARY_START_STATE_KEY: 'ORDER_SUMMARY_START_DATA',
  PDL_ORDER_SUMMARY_PRINT_CLICK: 'pdl-order-summary-print-click',
  ORDER_SUMMARY_END_PRINT_KEY: 'ORDER_SUMMARY_END_PRINT_DATA',
  TOOLS: 'pdl-track-tools-hierarchy',
  TOOLS_KEY: 'TOOLS_PREFERENCES',
  REPDASH: 'Repdash',
  REPDASH_TOOLS_NAVIGATION: 'pdl-track-repdash-tools-navigation',
  REPDASH_TOOLS_NAVIGATION_KEY: 'REPDASH_TOOLS_NAVIGATION_DATA',
  REPDASH_MEMO_CREATION: 'pdl-track-memo',
  REPDASH_MEMO_CREATION_KEY: 'REPDASH_MEMO_CREATION',
  REP_NTID: 'repNTId',
  ALERT_IMPRESSIONS_ATTRIBUTE_SELECTOR: 'div p a',
  PREPAID: '/prepaid/',
  CONTENT_JSON: '.content.json',
  BROWSE_DEVICES_KEY: 'BROWSE_DEVICES',
  PDL_TRACK_CANCEL_AUTO_PAY_COMPLETE: 'pdl-track-cancel-auto-pay-complete',
  PDL_TRACK_CANCEL_AUTO_PAY_START: 'pdl-track-cancel-auto-pay-start',
  REFILL_ACCOUNT_STATE: 'prepaid.refill-account',
  PDL_MODIFY_PAYMENT_METHOD_START: 'pdl-track-edit-payment-start',
  PDL_MODIFY_PAYMENT_METHOD_COMPLETE: 'pdl-track-edit-payment-complete',
  PDL_APPLY_CREDIT_START: 'pdl-track-apply-credit-start',
  PDL_APPLY_CREDIT_COMPLETE: 'pdl-track-apply-credit-complete',
  PDL_RETURN_EXCHANGE_COMPLETE: 'pdl-track-return-exchange-complete',
  PDL_EDIT_EMAIL_COMPLETE: 'pdl-track-edit-email-complete',
};

export const PDL_EVENT_CONSTANT_MAP = {
  DEFAULT: {
    EVENT_ACTION: '',
    EVENT_TYPE: '',
    EVENT_CATEGORY: '',
    EVENT_ANALYTICS: [],
  },
  API_ERROR: {
    EVENT_ACTION: 'error',
    EVENT_TYPE: 'system',
    EVENT_CATEGORY: 'error',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  USER_ERROR: {
    EVENT_ACTION: 'error',
    EVENT_TYPE: 'user',
    EVENT_CATEGORY: 'error',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  PAGE_LOAD: {
    EVENT_ACTION: 'load',
    EVENT_TYPE: 'page',
    EVENT_CATEGORY: 'start',
    EVENT_ANALYTICS: ['pageInfo'],
  },
  ADD_A_LINE: {
    EVENT_ACTION: 'click',
    EVENT_TYPE: 'add a line',
    EVENT_CATEGORY: 'click',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  LOGIN_START: {
    EVENT_ACTION: 'login',
    EVENT_CATEGORY: 'account',
    EVENT_TYPE: 'start',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  LOGIN_COMPLETE: {
    EVENT_ACTION: 'login',
    EVENT_CATEGORY: 'account',
    EVENT_TYPE: 'complete',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'user'],
  },
  FORM: {
    EVENT_ACTION: ' ',
    EVENT_TYPE: ' ',
    EVENT_CATEGORY: 'form',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  PRODUCT_SELECTION: {
    EVENT_ACTION: 'productSelection',
    EVENT_TYPE: 'cart',
    EVENT_CATEGORY: 'cart',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'offer'],
  },
  GLOBAL_SEARCH: {
    EVENT_ACTION: 'search initiation',
    EVENT_TYPE: 'internal search',
    EVENT_CATEGORY: 'search',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  INTERNAL_CAMPAIGN: {
    EVENT_ACTION: 'impression',
    EVENT_TYPE: 'internal campaign',
    EVENT_CATEGORY: 'impression',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  ADD_TO_CART: {
    EVENT_ACTION: 'cartAdd',
    EVENT_TYPE: 'cart',
    EVENT_CATEGORY: 'cart',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'offer'],
  },
  SEARCH_RESULT_CLICK: {
    EVENT_ACTION: 'search result click',
    EVENT_TYPE: 'internal search',
    EVENT_CATEGORY: 'search',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  COMMUNICATION_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update communication preferences',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  CHECK_ORDER_STATUS: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'Check Order Status',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  BLOCKING_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'Manage blocking controls',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  BLOCKING_PREFERENCES_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'Manage blocking controls',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  COMMUNICATION_PREFERENCES_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update communication preferences',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  EQUIP_INST_PLAN_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'pay EIP',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PRE_PAID_CONF_ONE_TIME_PAY_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'pay bill',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  MANAGE_AUTO_PAY_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'Setup AutoPay',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  MODIFY_AUTO_PAY_START_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'Modify AutoPay',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  MODIFY_AUTO_PAY_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'Modify AutoPay',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  CONF_MANAGE_AUTO_PAY_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'Setup AutoPay',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PDL_MODIFY_DATA_STASH_START_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'Modify Data Stash',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PDL_MODIFY_DATA_STASH_COMPLETE_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'Modify Data Stash',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PDL_SUSPEND_SERVICE_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'suspend service temporarily',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PDL_RESTORE_FROM_SUSPENDED_START_PREFERENCES: {
    EVENT_ACTION: 'click',
    EVENT_TYPE: 'restore from suspended',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PDL_RESTORE_FROM_SUSPENDED_COMPLETE_PREFERENCES: {
    EVENT_ACTION: 'click',
    EVENT_TYPE: 'restore from suspended complete',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PDL_SUSPEND_SERVICE_COMPLETE_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'suspend service temporarily',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  MAKE_ONE_TIME_PAYMENT_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'One Time Payment',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  CONF_MAKE_ONE_TIME_PAYMENT_KEY_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'One Time Payment',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  START_CANCEL_AUTO_PAY_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'Cancel AutoPay',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  COMPLETE_CANCEL_AUTO_PAY_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'Cancel AutoPay',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  IMEI_BLOCK_CHECK_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'check device unlock status',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  IMEI_BLOCK_CHECK_COMPLETE_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'check device unlock status',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  IMEI_BLOCK_CHECK_ERROR_PREFERENCES: {
    EVENT_ACTION: 'error',
    EVENT_TYPE: 'system',
    EVENT_CATEGORY: 'error',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  CPS_ALL_PLANS_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'CPS - change rate plan',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  LOST_STOLEN_PREFERENCES: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'report device lost or stolen',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  LOST_STOLEN_DEVICE_COMPLETE_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'report device lost or stolen',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  WEB_GUARD_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update WebGuard preferences',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  WEB_GUARD_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update WebGuard preferences',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  FAMILY_ALLOWANCE_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'change family allowances',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  FAMILY_ALLOWANCE_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'change family allowances',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_NAME_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update name',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_NAME_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update name',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_EMAIL_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update email address',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_EMAIL_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update email address',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_PHONE_NUMBER_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update contact number',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  PROFILE_PHONE_NUMBER_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update contact number',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  PROFILE_PASSWORD_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update password',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_PASSWORD_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update password',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_SECURITY_QUESTIONS_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update security questions',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  PROFILE_SECURITY_QUESTIONS_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update security questions',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  PROFILE_BILLING_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update billing address',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_BILLING_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update billing address',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_E911_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'update E911 address',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_E911_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'update E911 address',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PRICE_CHANGE_NOTIFICATION: {
    EVENT_ACTION: 'pricingChangeNotification',
    EVENT_TYPE: 'cart',
    EVENT_CATEGORY: 'cart',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  EMPLOYEE_DESIGNATION_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'employee line designation',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  EMPLOYEE_DESIGNATION_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'employee line designation',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  MAKE_PAYMENT_ARRANGEMENT_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'make payment arrangement',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  USER_REGISTRATION_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'registration',
    EVENT_CATEGORY: 'user',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  USER_REGISTRATION_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'registration',
    EVENT_CATEGORY: 'user',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'user'],
  },
  PREPAID_ONE_TIME_PAYMENT_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'pay bill',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  EQUIPMENT_INSTALLMENT_PLAN_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'pay EIP',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  SIM_CHANGE_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'change SIM card',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  SIM_CHANGE_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'change SIM card',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_PAPERLESS_BILLING_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'sign up for paperless billing',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PROFILE_PAPERLESS_BILLING_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'sign up for paperless billing',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  NAV_CLICK_EVENT: {
    EVENT_ACTION: 'click',
    EVENT_TYPE: 'navClick',
    EVENT_CATEGORY: 'navClick',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'link'],
  },
  MOVE_A_LINE_CLICK: {
    EVENT_ACTION: 'Rep Actions',
    EVENT_TYPE: 'Move a Line',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  CPS_ADD_FEATURE_CLICK: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'CPS - add feature',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  EDITHANDLING_CLICK: {
    EVENT_ACTION: 'Rep Actions',
    EVENT_TYPE: 'Edit Handling',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  RESUME_LINE_CLICK: {
    EVENT_ACTION: 'Rep Actions',
    EVENT_TYPE: 'Resume Line',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  MODIFY_CANCELLATION_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'Modify Cancellation',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  MODIFY_CANCELLATION_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'Modify Cancellation',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  CANCEL_LINES_CLICK: {
    EVENT_ACTION: 'Rep Actions',
    EVENT_TYPE: 'Cancel Line',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  MODIFICATION_CLICK: {
    EVENT_ACTION: 'Rep Actions',
    EVENT_TYPE: 'Modify Cancellation',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  PDL_REPDASH_ACTIVITY_CLICK: {
    EVENT_ACTION: 'Filter Applied',
    EVENT_TYPE: 'Activity Type',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  REPDASH_USAGE_FILTER_CLICK: {
    EVENT_ACTION: 'Filter Applied',
    EVENT_TYPE: 'Usage',
    EVENT_CATEGORY: 'repdash',
    SEARCH_BY: '',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  REPDASH_MRC_FILTER_CLICK: {
    EVENT_ACTION: 'Filter Applied',
    EVENT_TYPE: ' User (MRC Summary)',
    EVENT_CATEGORY: 'repdash',
    SEARCH_BY: '',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  INFOBAR_CLICK_EVENT: {
    EVENT_ACTION: 'click',
    EVENT_TYPE: 'repdash click',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'link'],
  },
  PIN_CHECK_BOX_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'customer verification',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  CUSTOMER_LOOKUP_PREFRENCES: {
    EVENT_ACTION: 'search initiation',
    EVENT_TYPE: 'customer lookup',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  ORDER_LOOKUP_PREFRENCES: {
    EVENT_ACTION: 'search initiation',
    EVENT_TYPE: 'order lookup',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  PROMOTION_LOOKUP_PREFRENCES: {
    EVENT_ACTION: 'search initiation',
    EVENT_TYPE: 'promo lookup',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  SUBMIT_FOLLOWUP_PREFRENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'repdash followup',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  SWITCH_ACCOUNT_PREFERENCES: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'switch account',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  ORDER_SUMMARY_START_DATA: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'print bill',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  ORDER_SUMMARY_END_PRINT_DATA: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'print bill',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  TOOLS_PREFERENCES: {
    EVENT_ACTION: 'click',
    EVENT_TYPE: 'repdash click',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['link', 'eventInfo', 'category'],
  },
  VIDEO_PROGRESS: {
    EVENT_ACTION: '',
    EVENT_TYPE: 'video',
    EVENT_CATEGORY: 'video',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  VIDEO_COMPLETE: {
    EVENT_ACTION: '',
    EVENT_TYPE: 'video',
    EVENT_CATEGORY: 'video',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  REPDASH_MEMO_CREATION: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'memo creation',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  REPDASH_TOOLS_NAVIGATION_DATA: {
    EVENT_ACTION: 'click',
    EVENT_TYPE: 'repdash click',
    EVENT_CATEGORY: 'repdash',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes', 'link'],
  },
  ALERT_IMPRESSIONS: {
    EVENT_ACTION: 'impression',
    EVENT_TYPE: 'alert',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  ALERT_IMPRESSION_CLICK: {
    EVENT_ACTION: 'click',
    EVENT_TYPE: 'account action user alert',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  BROWSE_DEVICES: {
    EVENT_ACTION: 'browseDevices',
    EVENT_TYPE: 'cart',
    EVENT_CATEGORY: 'cart',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'offer'],
  },
  MODIFY_PAYMENT_START: {
    EVENT_ACTION: 'start',
    EVENT_TYPE: 'Modify Scheduled Payment',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  MODIFY_PAYMENT_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'Modify Scheduled Payment',
    EVENT_CATEGORY: 'account action',
    EVENT_ANALYTICS: ['eventInfo', 'category'],
  },
  APPLY_CREDIT_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'courtesyCreditForm complete',
    EVENT_CATEGORY: 'form',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
  RETURN_EXCHANGE_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'returnExchangeForm complete',
    EVENT_CATEGORY: 'form',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },

  EDIT_EMAIL_COMPLETE: {
    EVENT_ACTION: 'complete',
    EVENT_TYPE: 'editEmail complete',
    EVENT_CATEGORY: 'form',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },

  CARRIER_MAKE_MODEL: {
    EVENT_ACTION: 'search result click',
    EVENT_TYPE: 'internal search',
    EVENT_CATEGORY: 'search',
    // EVENT_ACTION: 'click',
    // EVENT_TYPE: 'check by carrier make and model',
    // EVENT_CATEGORY: 'byod',
    EVENT_ANALYTICS: ['eventInfo', 'category', 'attributes'],
  },
};

export const CHANNEL_IDS = {
  web: 'Web',
  retail: 'Retail',
  care: 'Care',
};

export const CHANNELS = {
  web: 'Unassisted',
  retail: 'In Person',
  care: 'Over the Phone',
};

export const SUB_CHANNELS = {
  TELE_SALES: 'TeleSales',
  CARE: 'Care',
  SELF_SERVICE_ANONYMOUS: 'Self Service Anonymous',
  SELF_SERVICE_AUTH: 'Self Service Authenticated',
};

export const PDL_EVENT_FILTER_MAP = {
  mouseenter: 'ui-select-choices-row',
  keyup: 'form-control',
};

export const IMEI_CONSTANTS = {
  BLOCKED: 'BLOCKED',
  AVAILABLE: 'AVAILABLE',
  CODE: 'code',
  DESCRIPTION: 'description',
  REQUIRED: 'required',
  MIN_LENGTH: 'MinLength',
  MAX_LENGTH: 'MaxLength',
  IMEI_ERROR: 'IMEI',
  ADD_IMEI_BLOCK: 'addimeiblock',
  REMOVE_IMEI_BLOCK: 'removeimeiblock',
  IMEI_LENGTH_ERROR: 'IMEI # (14-16 digits)',
  IMEI_CHECK_AEM: 'imeiCheck',
  IMEI_CHECK_CONFIRMATION_AEM: 'imeiCheck/confirmation',
  API_FAILURE_MESSAGE: 'Server error',
  BLOCK: 'BLOCK',
};

export const SYMBOL_CONSTANTS = {
  COLON: ' : ',
  MULTIPLE_VALUE_SEPARATOR: '_',
};

export const PDL_EVENT_TYPE = {
  FORM_START: 'form start',
  FORM_COMPLETE: 'form complete',
  CLICK_TO_ACTION: 'clickToAction',
  MODAL: 'modal',
  CLICK_TO_CALL: 'clickToCall',
};

export const PDL_EVENT_ACTION = {
  CLICK: 'click',
  LOAD: 'load',
};

export const PDL_FORM_GROUP = {
  CHECKOUT_ACCOUNT_SETUP: 'accountOwnerInfo',
  CHECKOUT_LINE_SETUP: 'pageTitle',
  CHECKOUT_SHIPPING: 'shippingAddress',
  CHECKOUT_PAYMENT: 'paymentMethod',
};

export const PDL_CTA_KEYS = {
  CHECKOUT_RESERVER_NUMBER: 'reserveNumber',
  CHECKOUT_SHIPPING_METHOD: 'optionDisplayName',
};

export const PDL_ASSET_TYPE = {
  BUTTON: 'Button',
  LINK: 'link',
  TEL: 'Tel',
  LINK_CAMEL_CASE: 'Link',
};

export const PDL_USER_SELECTION = {
  AUTO_NUMBER: 'Autogenerated number selected',
  LIST_NUMBER: 'Listed phone number selected',
};

export const PDL_MODAL_NAME = {
  NEW_NUMBER: 'getNewNumber',
  VALIDATE_ADDRESS: 'addressValidation',
  PROCESS_ORDER: 'processingOrder',
  CANCEL_CART: 'cancelCart',
  ORDER_PAYMENT_CANCEL: 'areYouSure',
};

export const PDL_EVENT_CTA_ID = {
  MODAL_LOAD_EVENT: 'modalLoadEvent',
  PAGE_LOAD: 'pageLoad',
  CLICK: 'click',
  ERROR: 'error',
  SEARCH: 'search',
};

export const PDL_MY_PROFILE = {
  ADD_PAYMENT_METHOD_CARD: 'Add Payment Method - Card',
};

export const PDL_PATH = {
  ROOT: 'digitalData',
  PAGE: {
    PAGE_INFO: {
      PAGE_TYPE: 'page.pageInfo.pageType',
    },
  },
  EVENT: {
    EVENT_INFO: {
      EVENT_TYPE: 'eventInfo.eventType',
      EVENT_ACTION: 'eventInfo.eventAction',
    },
    EVENT_DESCRIPTION: {
      USER_SELECTION: 'eventDescription.userSelection',
      FORM_NAME: 'eventDescription.formName',
      MODAL_NAME: 'eventDescription.modalName',
    },
    ATTRIBUTES: {
      PDL_MODAL_NAME: 'attributes.modalName',
      DYNAMIC_CONTENT: 'attributes.dynamicContent',
    },
    ERROR: 'error',
  },
};

export const PDL_DIGITAL_PATH = {
  CART: {
    PATH: 'digitalData.cart',
    LINE_COUNT: 'digitalData.cart.lineCount',
    ORDER: {
      ID: 'digitalData.cart.order.id',
    },
    PAYMENT: {
      TYPE: 'digitalData.cart.payment.type',
      METHOD: 'digitalData.cart.payment.method',
    },
    PRICE: {
      SHIPPING: {
        DUE_TODAY: 'digitalData.cart.price.shipping.dueToday',
      },
    },
    SHIPPING: {
      METHOD: 'digitalData.cart.shipping.method',
      DUE_TODAY: 'digitalData.cart.shipping.dueToday',
    },
  },
};

export const PDL_ORDER = {
  PAYMENT_METHOD: {
    CREDIT: 'Credit',
    DEBIT: 'Debit',
  },
  TRANSACTION_TYPE: {
    DEPOSIT: 'DEPOSIT',
  },
  METHOD_CODE: {
    PREPAID: 'Prepaid',
  },
  PRICE_COLLECTION: {
    SUBTOTAL: 'SUBTOTAL',
    TAX_AND_FEE: 'TAX_AND_FEE',
    TOTAL: 'TOTAL',
    SHIPPING: 'SHIPPING',
  },
};

export const PDL_PAYMENT_METHOD = {
  CARD: 'Card',
};

export const PDL_CART_PATH = {
  PRICING: {
    SUB_TOTAL: {
      PRICE_SUMMARY: {
        PAY_NOW_PRICE: {
          SALE_PRICE: {
            AMOUNT: 'pricing.subTotal.priceSummary.payNowPrice.salePrice.amount',
          },
        },
        MONTHLY_PRICE: {
          SALE_PRICE: {
            AMOUNT: 'pricing.subTotal.priceSummary.monthlyPrice.salePrice.amount',
          },
        },
      },
    },
    TAX: {
      TAX_TOTAL: {
        AMOUNT: 'pricing.tax.totalTax.amount',
      },
    },
    TOTAL: {
      PAY_NOW_PRICE: {
        SALE_PRICE: {
          AMOUNT: 'pricing.total.payNowPrice.salePrice.amount',
        },
      },
      MONTHLY_PRICE: {
        SALE_PRICE: {
          AMOUNT: 'pricing.total.monthlyPrice.salePrice.amount',
        },
      },
    },
  },
};

export const PDL_SHIPPING_PATH = {
  SELECTED_SHIPPING_OPTION: {
    SHIPMENT_OPTION_ID: 'selectedShippingOption.shipmentOptionId',
    OPTION_DISPLAY_NAME: 'selectedShippingOption.optionDisplayName',
    COST: {
      AMOUNT: 'selectedShippingOption.cost.amount',
    },
  },
};

export const PDL_SEARCH = {
  NO_RESULTS: 'no results',
};

export const PDL_BRANDS = {
  '': 'TMO Prepaid',
  TMOPrepaid: 'TMO Prepaid',
  connect: 'Connect',
};

export const PDL_SELF_SERVICE = {
  STAGE_START: 'start',
  STAGE_IN_PROGESS: 'in-progress',
  STAGE_COMPLETE: 'complete',
};

export const PDL_AUTOPAY_AUTOREFILL = {
  NAME: 'Manage AutoPay/AutoRefill',
  FORM_NAME: 'Add Payment Method - Card',
  EDIT_FORM_NAME: 'Edit Payment Method - Card',
  LEARN_MORE_MODAL_NAME: 'Payment start date',
  ENABLE_USER_SELECTION: 'Payment method saved',
  MANAGE_AUTOPAY: 'Manage AutoPay',
  SETUP_AUTOPAY: 'Setup AutoPay',
  MANAGE_CONFIRMATION: 'Manage Confirmation',
  SCHEDULE_CONFIRMATION: 'Schedule Confirmation',
  AUTOPAY: 'AutoPay',
  AUTOREFILL: 'AutoRefill',
};
export const PDL_ONE_TIME_PAYMENT = {
  NAME: 'One Time Payment',
  FORM_NAME: 'Add Payment Method - Card',
  ENABLE_USER_SELECTION: 'Payment method saved',
};
